import { useEffect } from "react";

import { Select } from "twyne-new.ui";

import { UNIT_OPTIONS } from "../utils/predefined_sizes";

export default function SelectUnit({ value, unit, onChangeUnit, options = UNIT_OPTIONS, ...props }) {
  const hasPredefined = options.some(option => option.value === 'predefined')

  useEffect(() => {
    if (value && !unit) {
      const newUnit = getUnit(value, hasPredefined)
      onChangeUnit(newUnit)
    }
  }, [value, unit, onChangeUnit, hasPredefined])

  return <Select
    value={unit || (hasPredefined ? 'predefined' : '')}
    onChange={option => onChangeUnit(option.value)}
    options={options}
    placeholder='Unit'
    {...props}
  />
}

export const getUnit = (value = '', hasPredefined, units = UNIT_OPTIONS) => {
  const unit = units.find(option => value.endsWith(option.value))
  return unit ? unit.value : hasPredefined ? 'predefined' : ''
}

export const removeUnit = (value = '', units = UNIT_OPTIONS) => {
  const unit = getUnit(value, false, units)
  return value.replace(unit, '')
}

export const getUnitDetails = (value = '') => {
  if (typeof value !== 'string' || value.includes('arbitrary')) {
    return {}
  }

  return { unit: getUnit(value), value: removeUnit(value) }
}
